"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDowngrade = void 0;
var constant_1 = require("../constant");
var hosts_1 = require("../utils/hosts");
var connection = function (host) {
    return new Promise(function (resolve) {
        var _a;
        if (!host) {
            resolve(false);
        }
        var _b = (0, hosts_1.hostCheck)((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host), isTest = _b.isTest, isLocal = _b.isLocal, isPre = _b.isPre;
        var env = function () {
            if (isTest || isLocal) {
                return 'test';
            }
            if (isPre) {
                return 'production';
            }
            return 'production';
        };
        var _c = constant_1.slsConfig[env()], logProject = _c.logProject, logStore = _c.logStore;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', "https://".concat(logProject, ".").concat(host, "/logstores/").concat(logStore, "/track?APIVersion=0.6.0&topic=connection-test&source=sls-web-track"), true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 0) {
                    resolve(false);
                }
                else {
                    resolve(true);
                }
            }
        };
        xhr.timeout = 3000;
        xhr.ontimeout = function () {
            resolve(false);
        };
        xhr.onerror = function () {
            resolve(false);
        };
        xhr.onabort = function () {
            resolve(false);
        };
        xhr.send();
    });
};
exports.isDowngrade = connection(constant_1.SLS_HOST);
